'use client';

import React from 'react';
import NavBar from '@/components/header/NavBar';
import Footer from '@/components/Footer/Footer';
import { Link } from '@/i18n/routing';
const CookiesPolicy: React.FC = () => {
  return (
    <>
      <NavBar />

      {/* Hero */}
      <div
        className="bg-cover bg-center bg-no-repeat h-96 lg:h-[500px] relative"
        style={{ backgroundImage: `url('/hero/Cookies.avif')` }}
      >
        <div className="absolute inset-0 bg-secondary/55 h-96 lg:h-[500px]" />
        <h1 className="absolute inset-0 flex items-center pt-20 lg:pt-40 justify-center text-white text-5xl lg:text-9xl font-extrabold text-center px-4">
          Cookies Policy
        </h1>
      </div>

      {/* Content */}
      <section className="max-w-4xl mx-auto px-4 lg:px-0 py-16 lg:py-24 text-gray-700 leading-relaxed">
        <p className="mb-6 text-sm text-gray-500">Last updated: September 23, 2026</p>

        <p className="mb-6">
          This Cookies Policy explains how Evinov (&quot;Evinov&quot;, &quot;we&quot;, &quot;us&quot;, or &quot;our&quot;)
          uses cookies and similar tracking technologies on our website. By continuing to browse or
          use our site, you agree to our use of cookies as described in this policy.
        </p>

        <h2 className="text-2xl font-bold text-secondary mt-10 mb-4">1. What Are Cookies?</h2>
        <p className="mb-6">
          Cookies are small text files placed on your device when you visit a website. They are
          widely used to make websites work more efficiently, improve user experience, and provide
          information to the site owners.
        </p>

        <h2 className="text-2xl font-bold text-secondary mt-10 mb-4">2. How We Use Cookies</h2>
        <p className="mb-4">Evinov uses cookies for the following purposes:</p>
        <ul className="list-disc pl-6 mb-6 space-y-2">
          <li><strong>Essential Cookies</strong> — required for the website to function properly, such as enabling navigation and secure areas of the site.</li>
          <li><strong>Performance & Analytics Cookies</strong> — help us understand how visitors interact with our website (e.g. Google Analytics), allowing us to improve content and performance.</li>
          <li><strong>Functionality Cookies</strong> — remember your preferences (such as language or region) to provide a more personalized experience.</li>
          <li><strong>Marketing Cookies</strong> — used to deliver relevant advertising and measure the effectiveness of our marketing campaigns.</li>
        </ul>

        <h2 className="text-2xl font-bold text-secondary mt-10 mb-4">3. Third-Party Cookies</h2>
        <p className="mb-6">
          In some cases, we use cookies provided by trusted third parties, such as analytics
          providers or social media platforms. These third parties may collect information about
          your online activities over time and across different websites.
        </p>

        <h2 className="text-2xl font-bold text-secondary mt-10 mb-4">4. Managing Cookies</h2>
        <p className="mb-6">
          You can control and manage cookies through your browser settings. Most browsers allow you
          to refuse or delete cookies. Please note that disabling certain cookies may affect the
          functionality of our website and limit your ability to use some features.
        </p>

        <h2 className="text-2xl font-bold text-secondary mt-10 mb-4">5. Changes to This Policy</h2>
        <p className="mb-6">
          We may update this Cookies Policy from time to time to reflect changes in technology,
          legislation, or our business practices. Any changes will be posted on this page with a
          revised &quot;Last updated&quot; date.
        </p>

        <h2 className="text-2xl font-bold text-secondary mt-10 mb-4">6. Contact Us</h2>
        <p>
          If you have any questions about our use of cookies, please contact us through our{' '}
          <Link href="/contact-us" className="text-secondary underline">Contact page</Link>.
        </p>
      </section>

      <Footer />
    </>
  );
};

export default CookiesPolicy;